/**
 * It's a generated file, preferable to extend this in external file
 */
import * as yup from 'common/yup';
import {enums} from 'types/enums';

export const LogLevelLogFilter = yup.object({
   filterType: yup
      .string()
      .oneOf(enums.filterType.keys)
      .default(enums.filterType.enum.LOG_LEVEL_FILTER),
   minimumLevel: yup
      .string()
      .oneOf(enums.minimumLevel.keys)
      .default(enums.minimumLevel.enum.LOG_DEBUG),
});
export type ILogLevelLogFilter = yup.InferType<typeof LogLevelLogFilter>;
